import { makeStyles } from "@mui/styles";
import {Theme} from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: 94,
    backgroundColor: theme.palette.primary.main,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  sideContainer: {
    width: 60,
  },
  iconContainer: {
    cursor: "pointer",
    width: 40,
    height: 40,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  icon: {
    color: theme.palette.white.main,
    height: 24,
    width: 24,
  },
}));

export default useStyles;
